// extracted by mini-css-extract-plugin
module.exports = {"caseFolders":"styles_caseFolders__2tUvX","container":"styles_container__173Bv","containerWithDetails":"styles_containerWithDetails__30q4V"};